var map = {
	"./agent_dev_img.webp": 5322,
	"./agent_web_img2.webp": 9371,
	"./ai-dev-img.webp": 3599,
	"./conversation_dev_img.webp": 7450,
	"./conversation_dev_img2.webp": 5044,
	"./custom-dev-img.webp": 6202,
	"./custom-dev-img2.webp": 1508,
	"./dark.webp": 329,
	"./glass_ui.webp": 9890,
	"./gradient.webp": 4105,
	"./mobile_dev_img2.webp": 7199,
	"./service_card_agent.webp": 6265,
	"./service_card_agent2.webp": 7121,
	"./service_card_ai.webp": 8622,
	"./service_card_cloud.webp": 8009,
	"./service_card_mobile.webp": 7858,
	"./service_card_web.webp": 998,
	"./web-dev-img.webp": 9229,
	"./web-dev-img2.webp": 2333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9007;